import { pxToRem } from '@back-office/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(
  (theme) => ({
    table: {
      minWidth: 1096,
      borderCollapse: 'separate',
    },
    headerCell: {
      padding: theme.spacing(2, 0, 1, 0),
      backgroundColor: theme.palette.common.lightGray,
      '&:first-child': {
        position: 'sticky',
        left: 0,
        minWidth: '240px',
        boxShadow: '0px 8px 4px 0px rgba(0,0,0,0.1);',
      },
      '&.last-child': {
        position: 'sticky',
        right: 0,
        width: '20%',
        boxShadow: '0px 8px 4px 0px rgba(0,0,0,0.1);',
      },
    },

    bodyRow: {
      verticalAlign: 'top',
      cursor: 'pointer',
    },
    bodyCell: {
      minWidth: '160px',
      '&:first-child': {
        position: 'sticky',
        left: 0,
        minWidth: '240px',
        backgroundColor: 'white',
        boxShadow: '0px 8px 4px 0px rgba(0,0,0,0.1);',
      },
      '&.last-child': {
        position: 'sticky',
        right: 0,
        width: '20%',
        paddingRight: '16px',
        backgroundColor: 'white',
        boxShadow: '0px 8px 4px 0px rgba(0,0,0,0.1);',
      },
      '& > p': {
        overflow: 'hidden',
        wordBreak: 'break-all',
      },
    },
    avatar: {
      width: pxToRem(14),
      height: pxToRem(14),
    },
    alert: {
      background: '#FFF1F0',
      border: '1px solid #FFA39E',
      boxSizing: 'border-box',
      borderRadius: '2px',
    },
    empty: {
      backgroundColor: 'white',
      '& > svg': {
        width: '10rem',
        height: '10rem',
        fill: 'none',
      },
    },
    disable: {
      cursor: 'not-allowed',
    },
    status: {
      wordBreak: 'break-all',
    },
  }),
  { name: 'RecurringFileList' }
);

export default useStyles;
